var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-row jusify-start"},[_c('CUIcon',{staticClass:"cursor-default margin-r-2 min-w-20",attrs:{"color":"primary","viewBox":"0 0 24 24","width":"20px","height":"20px"}},[_vm._v(" "+_vm._s(_vm.amenity.icon)+" ")]),_c('p',{staticClass:"margin-t-0"},[_vm._v(_vm._s(_vm.amenity.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }